import {I18nDatetimeFormatLocale, I18nDatetimeFormats} from '@/global/types/i18n';
import countries from "@/store/db/countries/items"

const ENABLED_LANGUAGES: string[] = process.env.VUE_APP_ENABLED_LANGUAGES.split(',');

const DATE_CONFIG: I18nDatetimeFormatLocale = {
    date: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    },
    time: {
        hour: 'numeric',
        minute: 'numeric'
    },
    datetime: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    }
}

export const datetimeFormats: I18nDatetimeFormats = ENABLED_LANGUAGES.reduce(
    (result: I18nDatetimeFormats, language: string): I18nDatetimeFormats => {

        result[language] = DATE_CONFIG;

        if (2 < language.length) {
            // We already have country in language code. So, return as is
            return result;
        }

        countries.forEach(country => result[`${language}-${country.alpha2}`] = DATE_CONFIG);

        return result;
    },
    {}
);